import { Box, Link } from '@mui/material';
import { ReactNode } from 'react';

type ComponentProps = {
  phoneNumber: string;
  message: ReactNode;
  onClick: (phoneNumber: string, message: ReactNode) => void;
};

export const PhoneNumberLink = ({ phoneNumber, message, onClick }: ComponentProps) => (
  <>
    <Link
      display={{ xs: 'block', sm: 'none' }}
      onClick={() => onClick(phoneNumber, message)}
      sx={{ cursor: 'pointer' }}
    >
      {phoneNumber}
    </Link>
    <Box display={{ xs: 'none', sm: 'block' }}>{phoneNumber}</Box>
  </>
);